import { render, staticRenderFns } from "./accountsCheckBlock.vue?vue&type=template&id=c5b1f5d8&scoped=true&"
import script from "./accountsCheckBlock.vue?vue&type=script&lang=js&"
export * from "./accountsCheckBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b1f5d8",
  null
  
)

export default component.exports